import gql from "graphql-tag";

export const createBatchObjective = gql`
  mutation CreateBatchObjective($data: ObjectiveCreateInput!) {
    createObjective(data: $data) {
      id
    }
  }
`;
